import { CheckCircle, Info, PlusSquare, Target } from "react-feather";
import { Link } from "react-router-dom";
import { Card, Col, Nav, NavItem, NavLink, Row } from "reactstrap";
import { All, CreateNewProject, Doing, Done, Href } from "../../../../constants";
import { useAppDispatch, useAppSelector } from "../../../../reduxToolkit/hooks";
import { setActiveTab } from "../../../../reduxToolkit/reducers/projectSlice";
import { routes } from "../../../../routers/routes";

const ProjectListHead = () => {

  const { activeTab } = useAppSelector((state) => state.project);
  const dispatch = useAppDispatch();

  return (
    <Card>
      <Row>
        <Col md="6">
          <Nav tabs className="border-tab" id="top-tab">
            <NavItem><NavLink href={Href} className={activeTab === "1" ? "active" : ""} onClick={() => dispatch(setActiveTab("1"))}><Target />{All}</NavLink></NavItem>
            <NavItem><NavLink href={Href} className={activeTab === "2" ? "active" : ""} onClick={() => dispatch(setActiveTab("2"))}><Info />{Doing}</NavLink></NavItem>
            <NavItem><NavLink href={Href} className={activeTab === "3" ? "active" : ""} onClick={() => dispatch(setActiveTab("3"))}><CheckCircle />{Done}</NavLink></NavItem>
          </Nav>
        </Col>
        <Col md="6">
          <Link className="btn btn-primary d-flex align-items-center" to={routes.Project.Create}><PlusSquare />{CreateNewProject}</Link>
        </Col>
      </Row>
    </Card>
  );
};

export default ProjectListHead;